import { cloneElement, isValidElement, ReactNode } from 'react';

import Header from '../Header/Header';
import ModalWrapper from './HealthMonitor/DeviceDetails/ModalWrapper';
import Loader from './Loader/Loader';
import Footer from '../Footer/Footer';
import { FilterType } from '../../../enum/FilterType';
import useSetHeaderFilterType from '../../../hook/useSetHeaderFilterType';

interface Props {
  title: string;
  children?: ReactNode;
  filterType?: FilterType;
  icon: string;
}

const Content: React.FC<Props> = ({ title, children, filterType, icon }) => {
  useSetHeaderFilterType(filterType);

  /**
 * isValidElement(children) ? 
        cloneElement...
 * If `children` is a valid React element, this code clones it and injects additional props into it.
 * This allows the child component to access and manipulate the parent’s state without explicitly
 * passing these props at every level.
 *
 */

  return (
    <>
      <Header title={title} icon={icon}></Header>

      {isValidElement(children) ? cloneElement(children as React.ReactElement<any>) : <div className="content"></div>}

      <ModalWrapper></ModalWrapper>

      <Loader></Loader>

      <Footer></Footer>
    </>
  );
};

export default Content;
